<template>
     <q-layout data-testid="report-manager">
    <JtDocsViewer
      :src="fileSrc"
      :title="reportTitle"
      :pdf="reportFormat.pdf"
      :xls="reportFormat.xls"
      ref="reportModal"
      v-on:hide="emitCloseToBus"
    />
  </q-layout>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDocs } from 'jtech-webcomps'

const { page } = JtCrud
const { JtDocsViewer } = JtDocs
@Component({
  name: 'BillingOrderExportReport',
  components: {
    JtDocsViewer,
    page
  },
  props: {
    format: { type: String, required: true },
    forms: { type: Array, required: true }
  }
})
class BillingOrderExportReport extends Vue {
    fileSrc = null
    reportTitle = 'Relatório Pedidos à Exportar'
    dadosTelaFromRepository = []
    reportGenerationFormat = {
      online: true,
      scheduling: false
    }

    reportFormat = {
      pdf: true,
      xls: false
    }

    beforeMount () {
      if (this.format === 'pdf') {
        this.reportFormat = { pdf: true, xls: false }
      } else {
        this.reportFormat = { pdf: false, xls: true }
      }
      this.dadosTelaFromRepository = this.forms
    }

    async mounted () {
      await this.onGenerateReport()
    }

    emitCloseToBus () {
      this.$emit('on-close', {})
    }

    get computedDadosTelaFromRepository () {
      return Array.isArray(this.dadosTelaFromRepository) &&
      this.dadosTelaFromRepository.length
        ? this.dadosTelaFromRepository[0]
        : {}
    }

    async __whenGenerationFormatIsOnline ({ nmArquivo }) {
      try {
        const result = await this.$jt.repository.downloadFile(
          nmArquivo,
          this.format,
          '',
          'application/' + this.format
        )
        this.fileSrc = URL.createObjectURL(result)
        this.$nextTick(() => {
          if (this.reportFormat.xls) {
            this.__downloadFile(this.fileSrc, this.reportTitle, '.xls')
            this.emitCloseToBus()
          } else {
            this.$refs.reportModal.show()
          }
        })
        return Promise.resolve()
      } catch (error) {
        return Promise.reject(error)
      }
    }

    __downloadFile (fileSrc, fileName = 'downloaded_file', extension = '.xls') {
      const link = document.createElement('a')
      link.style = 'display: none'
      link.download = `${fileName}${extension}`
      link.href = fileSrc
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }

    async onGenerateReport () {
      try {
        this.$emit('generate', {
          dadosForm: this.computedDadosTelaFromRepository.dadosForm,
          nmInterface: this.computedDadosTelaFromRepository.nmInterface
        })
        const resolveLogicResult = await this.$jt.repository.resolveLogic(
          this.computedDadosTelaFromRepository.nmInterface,
          this.computedDadosTelaFromRepository.dadosForm
        )
        await this.__whenGenerationFormatIsOnline(resolveLogicResult)
      } catch (error) {
        console.error(error)
      }
    }
}

export default BillingOrderExportReport
</script>

<style>

</style>
